var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-8cae00ac-38b6-4933-bb8d-5adf01f1e911",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "uuid-0fc45420-0a8a-43f9-a3e0-63658219a53c",
    cx: 541.45,
    cy: 540.31,
    r: 504,
    fill: "#868686"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "uuid-95aec959-2afb-4b29-bcc2-e3ac712adf3c",
    d: "m699.74,768.61l-147.05-147.05-147.05,147.05c-19.34,19.34-50.69,19.34-70.03,0-19.34-19.34-19.34-50.69,0-70.03l147.05-147.05-147.06-147.06c-19.34-19.34-19.34-50.69,0-70.03s50.69-19.34,70.03,0l147.05,147.05,147.05-147.05c19.34-19.34,50.69-19.34,70.03,0,19.34,19.34,19.34,50.69,0,70.03h0l-147.05,147.05,147.05,147.05c19.34,19.34,19.34,50.69,0,70.03-19.34,19.34-50.69,19.34-70.03,0h0l.02.02Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon2);
export default __webpack_public_path__ + "static/media/cross-icon-2.3347f4c703d1e4cfaf53138f259c3ef2.svg";
export { ForwardRef as ReactComponent };